import { render, staticRenderFns } from "./CrearEnvio.vue?vue&type=template&id=4ea39c7e&scoped=true"
import script from "./CrearEnvio.vue?vue&type=script&lang=js"
export * from "./CrearEnvio.vue?vue&type=script&lang=js"
import style0 from "./CrearEnvio.vue?vue&type=style&index=0&id=4ea39c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea39c7e",
  null
  
)

export default component.exports